import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () =>
      import(
        /* webpackChunkName: "download" */ "../views/download/download.vue"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/download",
    name: "download",
    component: () =>
      import(
        /* webpackChunkName: "download" */ "../views/download/download.vue"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/instruction",
    name: "instruction",
    component: () =>
      import(
        /* webpackChunkName: "instruction" */ "../views/instruction/instruction.vue"
      ),
    meta: {
      title: "",
    },
  },
  {
    path: "/hw_test_download",
    name: "hw_test_download",
    component: () =>
      import(
        /* webpackChunkName: "download" */ "../views/download/download.vue"
      ),
    meta: {
      title: "",
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
